import React, { Fragment } from 'react';
import imgHelp1 from '../../assets/images/help/straight-up.png';
import imgHelp2 from '../../assets/images/help/split.png';
import imgHelp3 from '../../assets/images/help/street.png';
import imgHelp4 from '../../assets/images/help/corner.png';
import imgHelp5 from '../../assets/images/help/six.png';
import imgHelp6 from '../../assets/images/help/column.png';
import imgHelp7 from '../../assets/images/help/dozen.png';
import imgHelp8 from '../../assets/images/help/red_black.png';
import imgHelp9 from '../../assets/images/help/even_odd.png';
import imgHelp10 from '../../assets/images/help/10.png';
import imgHelp11 from '../../assets/images/help/finals.png';
import imgHelp12 from '../../assets/images/help/snake.png';
import imgHelp13 from '../../assets/images/help/redsplit11.jpg';
import imgHelp14 from '../../assets/images/help/blacksplit.jpg';
import imgHelp15 from '../../assets/images/help/voisins.jpg';
import imgHelp16 from '../../assets/images/help/zero.jpg';
import imgHelp17 from '../../assets/images/help/Tierrrr.jpg';
import imgHelp18 from '../../assets/images/help/orphlines.jpg';
import { useTranslation } from '@pascal/pascal-core';
import LimitAndPayouts from "../../conatiners/payoutsAndResultsContainer/limitsAndPayouts";

const GAME_RULES_HELP_KEYS = new Array(29).fill(null).map((item, index) => index);
const sortedImages = {
  6: imgHelp1,
  7: imgHelp2,
  8: imgHelp3,
  9: imgHelp4,
  10: imgHelp5,
  11: imgHelp6,
  12: imgHelp7,
  13: imgHelp8,
  14: imgHelp9,
  15: imgHelp10,
  18: imgHelp11,
  19: imgHelp12,
  20: imgHelp13,
  22: imgHelp15,
  23: imgHelp16,
  24: imgHelp17,
  25: imgHelp18,
};

export const HelpPopup = () => {
  const t = useTranslation();
  return (
    <div className='help-popup-content'>
      {GAME_RULES_HELP_KEYS.map((item) => (
        <Fragment key={item}>
          <p className='help-popup-content-text'>{t(`GAME_RULES_P${item + 1}`)}</p>
          {!!sortedImages?.[item] && (
            <div className='c-m-game-rules-img'>
              <img src={sortedImages?.[item]} alt='' />
            </div>
          )}
          {!!sortedImages?.[item] && item === 20 && (
            <div className='c-m-game-rules-img'>
              <img src={imgHelp14} alt='' />
            </div>
          )}
        </Fragment>
      ))}
      {/* /!*<div className="help-popup-img-inner">*!/*/}
      {/*     /!*<img src={imgHelpPopup} alt=""/>*!/*/}
      {/* /!*</div>*!/*/}

      {/* LIMITS AND PAYOUTS START */}
      <div className='game-rule-limits-and-payouts'>
        <p className='game-rule-limits-and-payouts-txt'>{t('BET')}</p>
        <p className='game-rule-limits-and-payouts-txt'>{t('MAX_PAYOUT')}</p>
      </div>
      <LimitAndPayouts isFromRules />
      <br />
      {/* LIMITS AND PAYOUTS END */}

      <p className='help-popup-content-text'>{t(`CANCELATION_MESSAGE_1`)}</p>
      <p className='help-popup-content-text'>{t(`MALFUNCTION_MESSAGE_2`)}</p>
      <p className='help-popup-content-text'>{t(`RTP`)}: 97.30%</p>
    </div>
  );
};
